import React from "react";
import ListUsageTypes from "features/../../../shared/features/Settings/LargeFormat/UsageType";

const UsageTypeSettings = props => <ListUsageTypes {...props} />;

export default UsageTypeSettings;
